import { createContext, useContext } from 'react';
import type { MessageFeedbackDTO, UpsertMessageFeedbackInput } from '@shared/schemas/message-feedback';

export type ChatMessageFeedbackContextValue = {
  clear: (messageId: string) => void;
  feedbackByMessageId: ReadonlyMap<string, MessageFeedbackDTO>;
  submit: (messageId: string, input: UpsertMessageFeedbackInput) => void;
};

/** Null until the conversation exists on the server: no feedback before that. */
export const ChatMessageFeedbackContext = createContext<ChatMessageFeedbackContextValue | null>(null);

export function useChatMessageFeedback() {
  return useContext(ChatMessageFeedbackContext);
}
